import React from "react";
import { Iman } from "../../assets";
const ImageIntro = () => {
  return (
    <div className="w-full hidden md:flex relative items-center justify-center">
      <div className="w-[380px] h-[470px] rounded-md overflow-hidden">
        <img
          src={Iman}
          alt="Iman Saadat"
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
};

export default ImageIntro;
